import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { IdPErrorViewComponent } from './module/root/view/idp-error-view/idp-error-view.component';
import { childRoutes } from './module/idp/util/child-routes';
import { LoggedoutComponent } from './module/idp/view/loggedout/loggedout.component';

const routes: Routes = [
  {
    path: 'Citizen',
    children: childRoutes
  },
  {
    path: 'Employee',
    children: childRoutes
  },
  {
    path: 'EmployeePlus',
    children: childRoutes
  },
  {
    path: 'Sign',
    children: childRoutes
  },
  {
    path: 'idp',
    children: [
      {
        path: 'loggedout',
        component: LoggedoutComponent
      }
    ]
  },
  {
    path: '_error',
    component: IdPErrorViewComponent
  },
  {
    path: '**',
    redirectTo: '/_error?status=404'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
